import React, { Component, useState, useEffect } from 'react';
import * as ReactDOM from 'react-dom';
import Configdata from './Defaultdata';
import Usersession from './Usersession';
import usrf1 from './imgs/grlpfp.png';
import usrm1 from './imgs/boypfp.png';
import msg from './imgs/posting.png';
import crtusr from './imgs/create.png';
import setting from './imgs/settings.png';
import color from './imgs/color.jpeg';
import delt from './imgs/delete.png';
import service from './imgs/service.png';
import {stcolor} from './userdefaultdata';
import {showhidediv,loadwidgate,clrwidgate,gtdfltvid,setdvl,openemoji,configchat,insertpost,Exituser,removeusers} from './userdefaultdata';
import { getmessage} from './Dynamictable';
import Girlspfp from './Girlspics';
import Boyspfp from './Boyspics';
import axios from 'axios';

export default class Userpfp extends Component {

    constructor(props: any) {
   	super(props);
	this.state.name = "profilepic";
	
  	}
	
    state = {

	
        name: "profilepic",
       respdata: null,   
       url: "",
      pfp:usrf1,
      uset:{pfpid:0,age:0,utf:true,uname:'',points:0},
      isf:true,
      uage:0,
      pnt:0,
      pfpid:0,
      ismsgshow:true,
      ishidesetiing:false,
      serviceid:1,
      dob:"",	
    };
    setserverurl() {
        debugger;
        const appurl = Configdata.srvurl;
       
        this.setState({ url: appurl });
    }
    setcolor(e:any) {
        debugger;
        const ccb = document.getElementById('colorpicker') as HTMLInputElement;
        ccb.click();
        
    }
    handleColorChange = (event:any) => {
     const colr = event.target.value;
     stcolor(colr);
     //const ccb = document.getElementById('colorpicker') as HTMLInputElement;
     //ccb.style.display='none';
       
    }
  togglesetting(){
       const id = 'usersetdiv';
	const ishide = !this.state.ishidesetiing;
        showhidediv(ishide,id);
          this.setState({ ishidesetiing: ishide });
	  if(!ishide)showhidediv(true,'userdeletedv');
	
  }
   setmessage(e:any) {
        //debugger;
        const mgsshow = !this.state.ismsgshow; 
        showhidediv(mgsshow,'wgtmsg');
         this.setState({ ismsgshow: mgsshow });

    }
    createuser(e:any) {
        //debugger;
       // const subuser = <Createsubuser />; 
        //showhidediv(mgsshow,'wgtmsg');
        // this.setState({ ismsgshow: mgsshow });
         showhidediv(true,'chatprofiledivtop');

	loadwidgate('wigtarea',9);
    }
    deselectsrv(id:any){
      const dv = document.getElementById(id) as HTMLElement;
        if(dv)  
	dv.style.backgroundColor = '#bd4ae2';

     }
 selectservice(id:any){
      const dv = document.getElementById(id) as HTMLElement;
        if(dv)  
	dv.style.backgroundColor = 'green';

     }

     deseletallsrv(){
	this.deselectsrv('helthservice');
	this.deselectsrv('eduservice');
	this.deselectsrv('workservice');

     }
    componentDidMount() {
        debugger;
        
	this.setpfp();
        this.togglesetting();
        this.selectservice('helthservice');
    }
 
setpfp(){
         const upf = Usersession.getUserpfp();
       // alert(JSON.stringify(upf));
         let pfpcode = upf.pfpid;
         const ut = upf.utpid; 
         const ag = upf.age;
         const un = upf.uname;
	const point = upf.points;
        const udob = upf.dob;
	const isfm = upf.utf;
     
        this.setState({ name: un });
   	this.setState({ pnt: point });
        this.setState({ dob: udob });

         this.setState({ uage: ag });
	
	this.setState({ pfpid: pfpcode });
       
         
	this.setState({ isf: isfm });
	
	Usersession.setUsertypeid(ut);

	 

}
settingprofile(e:any){
 getmessage('Only silver user access ','Now You have offer and enjoy');

  this.togglesetting();
}    
validdeleteuser = (event:any) => {
         showhidediv(false,'userdeletedv');
         this.setState({ ishidesetiing: true });

	showhidediv(true,'usersetdiv');

               
      
}
cancelddeleteuser = (event:any) => {
         showhidediv(true,'userdeletedv');
      
}
submitservice = (event:any) => {
         const stype = this.state.serviceid;
         const userid = Usersession.getUserId();
         const txtkeys = document.getElementById('servicekeys') as HTMLInputElement;
          if(txtkeys){
		
		const utxt = txtkeys.value;
                const apiurl = '/addservicekeys';
		txtkeys.value = '';
                const obj = {uid:userid,tpid:stype,txt:utxt};
              // insertpost(apiurl,obj);
             getmessage('Please wait for chatgpt message','');

              this.insertkey(apiurl,obj);
	}	
       //  showhidediv(true,'userservice');
      
}
insertkey(url:any,jsondata:any){
try {
	           const response = axios.post(Configdata.srvurl + url,jsondata, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
                if(response){
		 response.then((result:any) => {
		const usercd = result.data;
                getmessage('Sumited service key successfully','');
               // alert(JSON.stringify(usercd));
                const txtchatgpt = document.getElementById('msgfromchatgpt') as HTMLElement;
                txtchatgpt.style.display = 'block';
		txtchatgpt.innerHTML = usercd;
                
	        });		
              
	     }
	   }
         
        catch (ex:any) {
           
        }

}
seletservice = (e:any) => {
        this.deseletallsrv();
        e.target.style.backgroundColor = 'green';
        const  eid = e.target.id;
        //alert(eid);
        if(eid =='helthservice')this.setState({ serviceid: 1 });

	else if(eid == 'eduservice')this.setState({ serviceid: 2 });

	else if(eid == 'workservice')this.setState({ serviceid: 3 });


        // showhidediv(true,'userservice');
      
}

cancelservice = (event:any) => {
         showhidediv(true,'userservice');
      
}

servicesetting = (event:any) => {
         showhidediv(false,'userservice');
      
}

ddeleteuser = (event:any) => {
          const txtdpin = document.getElementById('inputdelete') as HTMLInputElement;
          if(txtdpin){
		const userpin = Usersession.getUserpin();
		const dpin = txtdpin.value;
                if(userpin != dpin){
		 getmessage('Enter valid pin','');
		}
		else{
		this.deleteuserdata();
		}
	 }
         showhidediv(true,'userdeletedv');
      
}
deleteuserdata(){
                const uid = Usersession.getUserId();
	        const apiurl ="/deletesubuser";
                //alert(uid);
		const obj = {sid:uid};
		insertpost(apiurl,obj);
                const sbusers = Usersession.getsubusers(); 
               // alert(JSON.stringify(sbusers));
               const updateusers =  removeusers(sbusers,uid);
                Usersession.setsubusers(updateusers); 
               //alert(JSON.stringify(updateusers));

                Exituser();
}
 render() {

   
     return (

       <div style={{height:'25vh'}} className="c-pfp-line">
	<div style={{height:'auto',width:'100%'}}>  
 	    <div style={{height:'40px'}} className="search-title-bar">
                 <a href="#" className="blanka"  onClick={e=>this.setmessage(e)} title="Message setting" > 
			<div id="msgset" style={{top:'3px',float:'left'}} className="c-usr-profile">

		  	   <img src={msg} className="cht-pfp-img" />


             		</div>
	    </a>
	   <a href="#" className="blanka"  onClick={e=>this.createuser(e)} title="New user">
                       <div id="usercreate" style={{top:'3px',float:'left',marginLeft:'5px'}} className="c-usr-profile">

			 
				  <img src={crtusr} className="cht-pfp-img" />

			  
			
			</div>
                      </a>	
               <a href="#" className="blanka"  onClick={e=>this.validdeleteuser(e)} title="Delete user">
                       <div id="deleteuser" style={{top:'3px',float:'left',marginLeft:'5px'}} className="c-usr-profile">

			 
				  <img src={delt} className="cht-pfp-img" />

			  
			
			</div>
                      </a>		    
	    
             <a href="#" className="blanka"  onClick={e=>this.settingprofile(e)} title="Settings" > 
			<div id="settingsilver" style={{top:'3px'}} className="c-usr-profile">

		  	   <img src={setting} className="cht-pfp-img" />

             		</div>
	    </a>	
           
                     

			<a href="#" title="Profile">
			<div className="search-title-toggle" id="togglesearch">
			  
			</div>
			</a>
	    </div>
	</div>

	<div id="pfpimg"  className="c-frofile-img">
        {this.state.isf?(
	<Girlspfp itemid={this.state.pfpid} wth={'9vw'}  hgt={'100px'}/>
	):(
	<Boyspfp itemid={this.state.pfpid} wth={'9vw'}   hgt={'100px'} />
	)}
	
         {this.state.isf?(
         <div className="c-pfp-tp">Female<span></span></div>
	 ):(
	<div className="c-pfp-tp">Male<span></span></div>
	)}

	</div>
       <div className="c-user-nm-info">
        	<div id="username"  className="c-user-name">
	 	{this.state.name}
        	</div>
        	<div id="userpoint"  className="c-user-point">
			<span> Points: </span><span id="pointcnt">{this.state.pnt}</span>
        	</div>
          <div id="userpoint"  className="c-user-point">
			<span> DOB: </span><span id="pointdob">{this.state.dob}</span>
        	</div>

	</div>
   <div id="usersetdiv"  className="user-settings"> 
		
    		  
                      <a href="#" onClick={e=>this.setcolor(e)} title="Profile">
                       	<div className="setting-menu">
			 <span className="ptopmenu" style={{backgroundColor:'transparent'}}>
				<img src={color} className="cht-pfp-img" />

			   <input type="color" className="zeropx" id="colorpicker"  onChange={e=>this.handleColorChange(e)} />
			 </span>
			</div>
                      </a>
			 <a href="#" onClick={e=>this.servicesetting(e)} title="Services">
                       	<div className="setting-menu">
			 <span className="ptopmenu" style={{backgroundColor:'transparent'}}>
				<img src={service} style={{height:'30px',width:'30px'}} className="cht-pfp-img" />

			  
			 </span>
			</div>
                      </a>
			

		      
  </div>	
 <div id="userdeletedv" style={{display:'none'}}  className="user-settings"> 
		
    		  
                       	<div style={{width:'43%'}} className="setting-menu">
			 <span>
				
 <input type="text" placeholder="Enter pin" style={{width:'95%',float:'left',marginTop:'1%',height:'30px'}} id="inputdelete"  />
			 </span>
			</div>
                       <a href="#" onClick={e=>this.ddeleteuser(e)} title="Delete  user">
                       	<div className="setting-menu">
			 <span className="deleteuserdv">
				  <img src={delt} className="cht-pfp-img" />

			   </span>
			</div>
                      </a>
		     <a href="#" onClick={e=>this.cancelddeleteuser(e)} title="Delete  user">
                       	<div className="setting-menu">
			 <span  className="deleteuserdv">
				 Cancel 
			   </span>
			</div>
                      </a>

		      
  </div>
   
  <div id="userservice" style={{display:'none',height:'66vh',zIndex:'34000',paddingBottom:'1vh'}}  className="user-settings"> 
		  <div style={{width:'100%'}}>
             	 <div style={{width:'100%',height:'10vh'}}>
		   <a href="#" onClick={e=>this.seletservice(e)} title="Health service">
                       	<div className="setting-menu">
			 <span id="helthservice" style={{width:'23vw'}} className="serviceselect">
				 Health 
			   </span>
			</div>
                      </a>
		     <a href="#" onClick={e=>this.seletservice(e)} title="Education service">
                       	<div className="setting-menu">
			 <span id="eduservice"  style={{width:'23vw'}} className="serviceselect">
				 Education 
			   </span>
			</div>
                      </a>
			<a href="#" onClick={e=>this.seletservice(e)} title="Works service">
                       	<div className="setting-menu">
			 <span id="workservice" style={{width:'23vw'}} className="serviceselect">
				 Works 
			   </span>
			</div>
                      </a>
	
		</div>
    		   <div style={{width:'100%'}}>

                 
                       	<div style={{width:'46%',padding:'5px'}} className="setting-menu">
			 <span>
				
 <input type="text" placeholder="Enter relavant keys " style={{width:'95%',float:'left',marginTop:'0.5%',height:'30px'}} id="servicekeys"  />
			 </span>
			</div>
                      
		     <a href="#" onClick={e=>this.submitservice(e)} title="Submit service">
                       	<div  className="setting-menu">
			 <span style={{width:'auto',float:'right',top:'0px'}}  className="deleteuserdv">
				 Submit 
			   </span>
			</div>
                      </a>
                     <a href="#" onClick={e=>this.cancelservice(e)} title="Submit service">
                       	<div className="setting-menu">
			 <span style={{width:'auto',float:'right',top:'0px'}} className="deleteuserdv">
				 Cancel 
			   </span>
			</div>
                      </a>
		 </div>
                <div style={{width:'100%',position:'relative',top:'8vh'}}>
              <div  style={{width:'81vw',height:'36vh',position:'relative',top:'2vh',left:'5%',display:'block'}}>
		<div id="msgfromchatgpt" style={{width:'80vw',height:'35vh',top:'2px',left:'2px',overflow:'scroll',display:'block',textAlign:'justify'}} >
			Please wait some time after submite for message from chatgpt
		</div>

                 </div>
		</div>
	</div>	      
  </div>	
	

   </div>	
    
   
      );
}
}

